<template>
  <div class="item">
    <div class="item__columns">
      <div class="item__column item__column--shrink">
        <play-pause
          :is-playing="isPlaying"
          :is-loading="isLoading"
          :is-gallery="true"
          :show-increments="false"
          :theme="theme"
          @play="handlePlay"
          @pause="handlePause"
        ></play-pause>
      </div>
      <div class="item__column">
        <player-info
          :is-playing="isPlaying"
          :url="item.shortUrl"
          :title="item.name"
          :description="item.description"
          :is-classic="isClassic"
          :show-title="item.showTitle"
          :publish-date="displayDate"
          :show-title-link="null"
          :theme="theme"
        ></player-info>
      </div>
    </div>
  </div>
</template>

<script>
import PlayPause from '../Controls/PlayPause';
import PlayerInfo from '../PlayerInfo';

export default {
  name: 'gallery-item',
  // Vue3 (LP-4/MR-78 emits parity): declare the $emitted events so the parent
  // Gallery's listeners bind as component events, not native-attr fallthrough.
  emits: ['play', 'pause'],
  components: {
    PlayPause,
    PlayerInfo,
  },
  props: {
    item: Object,
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
    isPlaying: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isClassic: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    handlePlay() {
      this.$emit('play', this.item.id);
    },

    handlePause() {
      this.$emit('pause');
    },
  },
  computed: {
    displayDate() {
      return this.item.widgetPublishDate || this.item.timestampCreated;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  height: 3rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  padding: 0 0.75rem;

  &__columns {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin: 0 -0.75rem;
  }

  &__column {
    padding: 0 0.75rem;
    flex: 1 1 0;
    width: 0;
    &--shrink {
      flex: 0 0 0;
      width: auto;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
